export const testimonials = [
  {
    id: 1,
    stars: 5,
    name: "Parker",
    position: "Allergy Specialist",
    review:
      "MITSI allergy testing and immunotherapy service is incredibly efficient. Our patients are getting results faster. It’s a win-win!",
  },
  {
    id: 2,
    stars: 5,
    name: "Dr. Davis",
    position: "Cardiologist",
    review:
      "The Flow 7 system has been a fantastic addition to our practice. It helps us find vascular issues early. This has improved care for our patients.",
  },
  {
    id: 3,
    stars: 5,
    name: "Emily Williams",
    position: "Neurofeedback Practitioner",
    review:
      "The Brain Zen Pro program has made such a difference in our approach to treating ADHD and PTSD. Highly recommend!",
  },
  {
    id: 4,
    stars: 5,
    name: "Johnston",
    position: "Clinical Director",
    review:
      "The placental graft wound care solution has been a game-changer for our facility. We've seen faster healing times and better patient outcomes. Thanks for MITSI.",
  },
  {
    id: 5,
    stars: 5,
    name: "Dr. Harris",
    position: "Primary Care Physician",
    review:
      "MITSI has transformed my practice. The in-house lab has cut test wait times. It lets us give faster, more accurate diagnoses. Our patients love the quick results!",
  },
];